document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (!productForm) return;

  const variantSelector = productForm.querySelector('select[name="id"], input[name="id"]:checked');
  const mediaGallery = document.querySelector('.product__media-wrapper, .product-gallery, [data-product-media-wrapper]');
  
  if (!mediaGallery) return;

  // Tüm medya öğelerini al
  const allMediaItems = mediaGallery.querySelectorAll('[data-media-id], .product__media-item, .product-gallery__item');
  
  // Varyant değişikliklerini dinle
  function handleVariantChange() {
    const selectedVariantId = getSelectedVariantId();
    if (!selectedVariantId) return;

    allMediaItems.forEach(item => {
      const mediaVariantIds = item.dataset.variantIds ? item.dataset.variantIds.split(',') : [];
      
      if (mediaVariantIds.length > 0) {
        // Bu resim bir varyanta atanmış
        if (mediaVariantIds.includes(selectedVariantId)) {
          item.style.display = ''; // Göster
          item.classList.remove('hidden-variant-media');
        } else {
          item.style.display = 'none'; // Gizle
          item.classList.add('hidden-variant-media');
        }
      } else {
        // Varyanta atanmamış resimler her zaman görünsün
        item.style.display = '';
        item.classList.remove('hidden-variant-media');
      }
    });
  }

  function getSelectedVariantId() {
    const select = productForm.querySelector('select[name="id"]');
    if (select) return select.value;
    
    const radio = productForm.querySelector('input[name="id"]:checked');
    if (radio) return radio.value;
    
    return null;
  }

  // Event listener'ları ekle
  productForm.addEventListener('change', handleVariantChange);
  
  // Sayfa yüklendiğinde çalıştır
  handleVariantChange();
});
